module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Отправить уведомление получателю":"Send notification to beneficiary","Выберите способ":"Select method","Способ уведомления":"Notification method","Язык сообщения":"Message language","Выберите язык":"Select language","Русский":"Russian","Английский":"English","Номер телефона":"Phone number"}}')
  delete Component.options._Ctor
}
